<div class="content">

  <div class="row">
    <div class="col-12">
      <div class="header-wrapper" [ngClass]="{'bg-default': data.CLIENT_USER?.CLIENT, 'bg-changed': !data.CLIENT_USER?.CLIENT}">
        <div class="user">
          <ngx-avatar name="{{data.CLIENT_USER?.NAME}}" size="48"></ngx-avatar>
          <div class="user-name">{{data.CLIENT_USER?.NAME}}</div>
          <div class="user-email" *ngIf="data.CLIENT_USER.EMAIL">
            <a href="mailto:{{data.CLIENT_USER.EMAIL}}">{{data.CLIENT_USER.EMAIL}}</a>
          </div>
        </div>
        <div class="company" *ngIf="data.CLIENT_USER.CLIENT">
          {{data.CLIENT_USER.CLIENT.COMPANY_NAME}}
        </div>
      </div>

    </div>
  </div>

  <div *ngIf="data.CLIENT_USER.ADDRESS" class="row data-row">
    <div class="col-12">
      <label>Address</label>
      <div class="value">
        {{data.CLIENT_USER?.ADDRESS?.length > 0 && data.CLIENT_USER?.ADDRESS != null ? data.CLIENT_USER?.ADDRESS+", " : ""}}
        {{data.CLIENT_USER?.ADDRESS2?.length > 0 && data.CLIENT_USER?.ADDRESS2 != null ? data.CLIENT_USER?.ADDRESS2+", " : ""}}
        {{data.CLIENT_USER?.CITY}}, {{data.CLIENT_USER?.STATE}} {{data.CLIENT_USER?.ZIP}}
      </div>
    </div>
  </div>

  <div *ngIf="data.CLIENT_USER.ENG_ADDRESS" class="row data-row">
    <div class="col-12">
      <label>Engagment Letter Address</label>
      <div class="value">
        {{data.CLIENT_USER?.ENG_ADDRESS}}
      </div>
    </div>
  </div>

  <div class="row data-row" *ngIf="data.CLIENT_USER.PHONE_OFFICE">
    <div class="col-12">
      <label>Phone Business</label>
      <div class="value">
        <a href="tel://{{data.CLIENT_USER.PHONE_OFFICE}}">{{data.CLIENT_USER.PHONE_OFFICE}}</a>
        <span class="ml-2" *ngIf="data.CLIENT_USER.PHONE_EXT"><b>Ext:</b> {{data.CLIENT_USER.PHONE_EXT}}</span>
      </div>
    </div>
  </div>

  <div class="row data-row" *ngIf="data.CLIENT_USER.PHONE_PERSONAL">
    <div class="col-12">
      <label>Phone Personal</label>
      <div class="value">
        <a href="tel://{{data.CLIENT_USER.PHONE_PERSONAL}}">{{data.CLIENT_USER.PHONE_PERSONAL}}</a>
      </div>
    </div>
  </div>

  <div class="row data-row" *ngIf="data.CLIENT_USER.PHONE_MOBILE">
    <div class="col-12">
      <label>Phone</label><br/>
      <a href="tel://{{data.CLIENT_USER.PHONE_MOBILE}}">{{data.CLIENT_USER.PHONE_MOBILE}}</a>
    </div>
  </div>

  <div class="row data-row" *ngIf="data.CLIENT_USER.PHONE_FAX">
    <div class="col-12">
      <label>Fax</label><br/>
      <a href="tel://{{data.CLIENT_USER.PHONE_FAX}}">{{data.CLIENT_USER.PHONE_FAX}}</a>
    </div>
  </div>

  <div class="row data-row" *ngIf="data.CLIENT_USER.NOTES">
    <div class="col-12">
      <label>Notes</label>
      <div class="value">{{data.CLIENT_USER.NOTES}}</div>
    </div>
  </div>

</div>
